/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], function(){
	'use strict';

	var ElementStyleUtils = function(){
		return {

			_sanityCheck(elementStyles){
				return elementStyles && elementStyles.length > 0;
			},

			_filterByType(elementStyles, types){
				elementStyles = elementStyles || [];
				return elementStyles.filter( (elementStyle) => types.includes(elementStyle.type));
			},

			_getProperties(elementStyles){
				let properties = [];
				if (this._sanityCheck(elementStyles)){
					const styles = this._filterByType(elementStyles, ['visualitem','customdata']);
					if (styles && styles.length > 0){
						const payload = styles[0].values[0].payload;
						properties = payload.getProperties();
					}
				}
				return properties;
			},

			_findPropertyByName(elementStyles, name){
				const properties = this._getProperties(elementStyles);
				return !!properties.find( (property) => {
					return property.getName() === name;
				});
			},

			supportsContrastLabelColor: function(elementStyles){
				return !!this.getContrastPropertyName(elementStyles);
			},

			getContrastPropertyName: function(elementStyles){
				const contrastProperties = ['contrast.label.color', 'labels.contrast.color'];
				return contrastProperties.find(property => this._findPropertyByName(elementStyles,property));
			},

			isExtendedStyleSuffix: function(propertyToFind){
				//property other than color and font
				const otherProps = ['.title','contrast.label.color','labels.contrast.color','label.shadow'];
				return otherProps.indexOf(propertyToFind) !== -1;

			},

			getVidaTextStyleSuffix: function(elementStyles){

				let vidaVisSuffix = {
					color: '.color',
					fontSize: 'size',
					font: 'family',
					bold: 'weight',
					italic: 'style',
					title: '.title',
					contrastLabelColor: 'contrast.label.color',
					labelShadow: 'label.shadow'
				};

				if (this.supportsContrastLabelColor(elementStyles)){
					vidaVisSuffix.contrastLabelColor = this.getContrastPropertyName(elementStyles);
				}

				return vidaVisSuffix;

			},

			supportsLabelShadow: function(elementStyles){
				const labelShadow = 'label.shadow';
				return this._findPropertyByName(elementStyles,labelShadow);
			},

			supportsTitle: function(elementStyles){
				const titleSuffix = '.title';
				return !!this.findPropertyIdBySuffix(elementStyles,titleSuffix);
			},

			_nameMapping: function(name){
				if (name){
					//temp work around, vida will fix it in 3.x
					const aliasMapping = {
						'widget.legend.labels.color':'widget.legend.color',
						'widget.legend.labels.font':'widget.legend.font'
					};
					Object.keys(aliasMapping).forEach((key) => {
						if (name.startsWith(key) && aliasMapping[key]){
							name = name.replace(key,aliasMapping[key]);
						}
					});
				}
				return name;
			},

			_getAliasName(property, propertyIdList){
				let name = property.getName();
				if (propertyIdList && !propertyIdList.includes(name)){
					const aliases = property.getAliases ? property.getAliases():[];
					name = aliases.find((alias) => propertyIdList.includes(alias));
				}
				if (!name){
					name = this._nameMapping(property.getName());
				}
				return name;
			},

			findPropertyIdBySuffix: function (elementStyles, suffix, propertyIdList) {
				const suffixToTypeMap = {
					'.font': 'font',
					'.color': 'color',
					'.title': 'string',
					'contrast.label.color': 'boolean',
					'valueLabels.contrast': 'boolean',
					'label.shadow':'boolean'
				};
				let propertyId = null;
				const properties = this._getProperties(elementStyles);
				const type = suffixToTypeMap[suffix];
				if ( type && properties){
					let property = properties.find( (property) => {
						const name = property.getName().toLowerCase();
						return (name.endsWith(suffix) || name.endsWith(type))  && property.type === type;
					});
					if (property ){
						const name = property.getName();
						if (propertyIdList){
							propertyId = this._getAliasName(property, propertyIdList);
						}else{
							propertyId = name;
						}
					}
				}
				return propertyId;
			},

			_getElementKeyValue(elementStyles, types, defaultValue){
				if (this._sanityCheck(elementStyles)){
					const styles = this._filterByType(elementStyles, types);
					if (styles && styles.length > 0){
						return styles[0].key;
					}
				}
				return defaultValue;
			},

			getPropertyPrefix(elementStyles){
				return this._getElementKeyValue(elementStyles,['visualitem','customdata'], '');
			},

			getElementTitle(elementStyles){
				return this._getElementKeyValue(elementStyles,['elementTitle'], null);
			}

		};
	};

	return new ElementStyleUtils();
});
